jQuery( document ).ready(function( $ ) {

	//#1 custom admin pages - help info
	//open typography hints in pw-panel

	//default theme
	var $newtogglers = $('.page-2910- a, .page-8106- a');
    $newtogglers.each(function() {
       var $toggler = $(this);
       pwPanels.addPanel($toggler);
   });

	//cal preview
	//pwPanels.addPanel($('.page-8106- a'));



	//#2
	// var previewlink = $('.ProcessPageEdit-template-download-publication .page-view-action-modal a');

	// 	previewlink.attr('href',previewlink.attr('href') + "?preview=1");
	// 	previewlink.append(' * Preview *');


// ready end
});